<template>
  <footer v-if="isVisible" class="mmp_footer">
    <div ref="footerInner" class="inner">
      <TextMenu />
    </div>
  </footer>
</template>

<script>
import Vue from 'vue'
import MmpUtils from '@/plugins/_common/MmpUtils'
import commonMixin from '@/mixin/commonMixin'
import NrwCommonApi from './NrwCommon.js'
import TextMenu from '~pages/nrw/portlet/TextMenu.vue'

Vue.use(NrwCommonApi)

export default {
  name: 'MrwFooter',
  components: { MmpUtils, TextMenu },
  mixins: [commonMixin],
  data () {
    return {
      isLoaded: false,
      htmlClass: ['has_mmp_footer'], // footer 존재를 선언하기 위해 <html> 태그에 추가할 클래스명
      viewportWidth: 0, // 브라우저 뷰포트 width
      viewportHeight: 0, // 브라우저 뷰포트 height
      isVisible: false,
      hasBottomNav: false // 모바일 바텀 메뉴 영역 존재 여부
    }
  },
  computed: {
    // 현재 디바이스 viewport width 가 데스크탑 사이즈인 경우 true
    isDesktop () {
      return window.vue.getStore('homeInfo').state.isDeskTopMode
    },
    footerHtml () {
      const homeInfoStore = window.vue.getStore('homeInfo')
      const mobileInfo = homeInfoStore.getters.mobileInfo
      return mobileInfo.footrSntncTagCntnt // 풋터 HTML
    }
  },
  mounted () {
    this.addHeaderClass()
    this.getFooterHtml()
    this.evt()
  },
  async created () {
    let scriptUrl = '//wcs.naver.net/wcslog.js'
    this.isLoaded = await this.$loadScript(scriptUrl, 'naver_log', 10000, 10)
    console.log('loadScript after:', scriptUrl)
    this.afterScript()
  },
  methods: {
    addHeaderClass () {
      const htmlTag = document.querySelector('html')
      const htmlClass = this.htmlClass
      if (htmlTag) {
        htmlTag.classList.add(htmlClass)
      }
    },
    // <html> 태그에 헤더 존재를 선언하기 위해 추가한 클래스 제거
    removeHeaderClass () {
      const htmlTag = document.querySelector('html')
      const htmlClass = this.htmlClass
      if (htmlTag && htmlTag.classList.contains(htmlClass)) {
        htmlTag.classList.remove(htmlClass)
      }
    },
    getFooterHtml () {
      if (this.footerHtml) {
        this.isVisible = true
        this.$nextTick(() => {
          this.$refs.footerInner.insertAdjacentHTML('beforeend', this.footerHtml)
        })
      }
    },
    // 푸터 인터렉션 제어용 스크립트
    evt () {
      this.$nextTick(() => {
        const branchLinkBtns = document.querySelectorAll('.mmp_footer .wrap_footer_addr .btn_addr')
        const snsBtns = document.querySelectorAll('.mmp_footer .wrap_sns .btn_sns')
        let i

        // 지점 주소 보기 (MO)
        if (branchLinkBtns.length > 0) {
          for (i = 0; i < branchLinkBtns.length; i++) {
            branchLinkBtns[i].addEventListener('click', (e) => this.showAddr())
          }
        }

        // SNS 바로가기
        if (snsBtns.length > 0) {
          for (i = 0; i < snsBtns.length; i++) {
            snsBtns[i].addEventListener('click', (e) => this.goSns(e))
          }
        }
      })
    },
    // 주소보기 (모바일 전용)
    showAddr () {
      if (!this.isDesktop) {
        const target = event.currentTarget

        if (target.classList.contains('active')) {
          target.classList.remove('active')
        } else {
          target.classList.add('active')
        }
      }
    },
    // SNS 바로가기
    goSns (event) {
      const target = event.target
      const url = target.getAttribute('data-url')
      window.open(url)
    },
    afterScript () {
      // eslint-disable-next-line
      if (!wcs_add) var wcs_add={}
      // eslint-disable-next-line
      window.wcs_add = {wa:"s_428898644b77"}
      // wcs_add["wa"] = "s_428898644b77"
      // eslint-disable-next-line
      if (!_nasa) var _nasa={}
      // eslint-disable-next-line
      if(window.wcs){
        // eslint-disable-next-line
        wcs.inflow()
        // eslint-disable-next-line
        wcs_do()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/nrw/layouts/NrwFooter.vue